import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
import styles from './job.module.css';
import stylesS from './skills.module.css';

const JobDetails = () => {
    const { jobId } = useParams();
    const [jobDetails, setJobDetails] = useState(null);
    const [applied, setApplied] = useState(false);
    const [companyProfile, setCompanyProfile] = useState({});
    const navigate = useNavigate();
    const token = useMemo(() => localStorage.getItem('token'), []);
    

    useEffect(() => {
        const fetchJobDetails = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'Please login first');
                    navigate('/login');
                    return;
                }
                const response = await axios.get(`/api/jobs/job-details/${jobId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setJobDetails(response.data);
                setCompanyProfile(response.data.companyProfile);
                console.log('Job Details:', response.data);
                // console.log('Job Details:', response.data.companyId);

            } catch (error) {
                // console.error('Error fetching job details:', error);
            }
        };

        fetchJobDetails();
    }, [navigate]);

    const handleApplyJob = async (jobId) => {
        try {
            await axios.post('/api/jobs/apply-job', { jobId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setApplied(true);
        } catch (error) {
            // const errorMessage = error.response?.data?.message || 'Error applying job:';
            // console.error(errorMessage);
        }
    };

    if (!jobDetails) {
        return <div>Loading</div>;
    }
    if (!companyProfile) {
        return <div>Loading</div>;
    }

    return (
        <>
        <NavHeader/>
        <div className={styles.jobDetails}>
        <div className={styles.jobDetailsHeader}>
            <img 
                src={companyProfile.logo 
                    ? companyProfile.logo.replace('/upload/', '/upload/w_192,h_200,c_fill/') 
                    : '/default-profile.png'
                }
                alt={`${companyProfile.name} logo`} 
                className={styles.companyLogo} 
            />
            <div className={styles.headerContent}>
                <h2 className={styles.jobTitle}>{jobDetails?.title}</h2>
                <span className={styles.jobStatus}>{jobDetails?.status}</span>
            </div>
        </div>

        <div className={styles.jobInfo}>
            <div className={styles.infoRow}>
                <span className={styles.label}>🏢 Company:</span>
                <span className={styles.value}>{companyProfile?.name}</span>
            </div>

            <div className={styles.infoRow}>
                <span className={styles.label}>📍 Location:</span>
                <div className={styles.value}>
                    {companyProfile?.location?.split('\n').map((line, i) => (
                        <div key={i} className={styles.locationLine}>{line}</div>
                    ))}
                </div>
            </div>

            <div className={styles.infoRow}>
                <span className={styles.label}>💼 Description:</span>
                <div className={styles.value}>
                    {jobDetails?.description?.split('\n').map((line, i) => (
                        <div key={i} className={styles.descriptionLine}>{line}</div>
                    ))}
                </div>
            </div>

            <div className={styles.infoRow}>
                <span className={styles.label}>✅ Requirements:</span>
                <div className={styles.value}>
                    {jobDetails?.requirements?.split('\n').map((line, i) => (
                        <div key={i} className={styles.requirementLine}>{line}</div>
                    ))}
                </div>
            </div>

            <div className={styles.infoRow}>
                <span className={styles.label}>🛠️ Skills:</span>
                <div className={styles.skillsContainer}>
                    {jobDetails?.skillNames?.map((skill, index) => (
                    <span key={index} className={stylesS[`skill${index % 11}`]}>
                            {skill.name}
                        </span>
                    ))}
                </div>
            </div>

            <div className={styles.infoRow}>
                <span className={styles.label}>🎁 Benefits:</span>
                <div className={styles.value}>
                    {jobDetails?.benefits?.split('\n').map((line, i) => (
                        <div key={i} className={styles.benefitLine}>{line}</div>
                    ))}
                </div>
            </div>

            <div className={styles.infoRow}>
                <span className={styles.label}>👥 Applicants:</span>
                <span className={styles.value}>{jobDetails?.numberOfApplicants}</span>
            </div>

            {jobDetails?.applicationStatus && (
                <div className={styles.infoRow}>
                    <span className={styles.label}>📊 Status:</span>
                    <span className={styles.value}>{jobDetails?.applicationStatus}</span>
                             
                </div>
            )}
            {jobDetails?.rejectionReasons?.length > 0 && (
                <div className={styles.infoRow}>
                    <h4 className={styles.label}>Rejection Reason:</h4>
                    <ul className={styles.value}>
                        {jobDetails.rejectionReasons.map((reason, index) => (
                            <li key={index} className={styles.rejectionItem}>
                                {reason}
                            </li>
                        ))}
                    </ul>
                </div>
            )}       
        </div>

        <div className={styles.actionSection}>
            {!jobDetails?.applicationSubmitted ? (
                !applied ? (
                    <button 
                        className={styles.applyButton} 
                        onClick={handleApplyJob.bind(null, jobId)}
                    >
                        Apply Now
                    </button>
                ) : (
                    <button className={`${styles.applyButton} ${styles.applied}`} disabled>
                        ✓ Applied
                    </button>
                )
            ) : (
                <div className={styles.appliedSection}>
                    <p className={styles.applicationDate}>
                        <strong>Application Submitted:</strong> {new Date(jobDetails.applicationSubmitted).toLocaleDateString()}
                    </p>
                    <button className={`${styles.applyButton} ${styles.applied}`} disabled>
                        ✓ Applied
                    </button>
                </div>
            )}
        </div>

        <div className={styles.companyProfile}>
            <h3 className={styles.sectionTitle}>Company Profile</h3>
            <div className={styles.companyCard}>
                {companyProfile.logo && (
                    <div className={styles.logoSection}>
                        <img src={companyProfile.logo 
                    ? companyProfile.logo.replace('/upload/', '/upload/w_260,h_194,c_fill/') 
                    : '/default-profile.png'
                }
                alt={`${companyProfile.name} logo`}  />
                    </div>
                )}
                
                <div className={styles.detailsSection}>
                    {companyProfile.name && <h2 className={styles.companyName}>{companyProfile.name}</h2>}
                    
                    <div className={styles.meta}>
                        {companyProfile.location && <p><strong>Location:</strong> {companyProfile.location}</p>}
                        {companyProfile.established && <p><strong>Established:</strong> {new Date(companyProfile.established).getFullYear()}</p>}
                        {companyProfile.additionalDetails?.industry && <p><strong>Industry:</strong> {companyProfile.additionalDetails.industry}</p>}
                        {companyProfile.additionalDetails?.size && <p><strong>Company Size:</strong> {companyProfile.additionalDetails.size}</p>}
                        {companyProfile.additionalDetails?.type && <p><strong>Company Type:</strong> {companyProfile.additionalDetails.type}</p>}
                        {companyProfile.website && (
                            <p><strong>Website:</strong> 
                                <a 
                                    href={companyProfile.website.startsWith("http") ? companyProfile.website : `https://${companyProfile.website}`} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className={styles.websiteLink}
                                >
                                    {companyProfile.website}
                                </a>
                            </p>
                        )}
                    </div>

                    {(companyProfile.email || companyProfile.phone || companyProfile.address) && (
                        <div className={styles.contact}>
                            <h4>Contact Information</h4>
                            {companyProfile.email && <p><strong>Email:</strong> {companyProfile.email}</p>}
                            {companyProfile.phone && <p><strong>Phone:</strong> {companyProfile.phone}</p>}
                            {companyProfile.address && <p><strong>Address:</strong> {companyProfile.address}</p>}
                        </div>
                    )}

                    {(companyProfile.mission || companyProfile.vision || companyProfile.culture) && (
                        <div className={styles.culture}>
                            <h4>Company Culture</h4>
                            {companyProfile.mission && <p><strong>Mission:</strong> {companyProfile.mission}</p>}
                            {companyProfile.vision && <p><strong>Vision:</strong> {companyProfile.vision}</p>}
                            {companyProfile.culture && <p><strong>Culture:</strong> {companyProfile.culture}</p>}
                        </div>
                    )}
                </div>
            </div>
        </div>
        </div>
        </>
    );
};

export default JobDetails;